import { useState } from "react";
import {
  mfgPrimaryBtnClass,
  mfgSecondaryBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";
import { confirmManufacturingRecipesReview } from "@/lib/manufacturingClient";

/** Banner + confirm CTA when a recipe is flagged needs_review after bulk upload. */
export function ManufacturingModelsNeedsReviewBanner({
  recipeId,
  pendingCount,
  onConfirmed,
  onError,
}: {
  recipeId: string;
  pendingCount: number;
  onConfirmed: () => void;
  onError: (msg: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const blocked = pendingCount > 0;

  async function confirm() {
    if (blocked) return;
    setBusy(true);
    const result = await confirmManufacturingRecipesReview({ recipe_ids: [recipeId] });
    setBusy(false);
    if (!result.ok) {
      onError(result.error || "Confirm failed");
      return;
    }
    if (result.data.blocked.length > 0) {
      onError("Cannot confirm while pending material lines remain.");
      return;
    }
    onConfirmed();
  }

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 px-3 py-3 text-sm text-amber-950 dark:border-amber-700 dark:bg-amber-900/30 dark:text-amber-100">
      <div className="font-medium">Needs review</div>
      <p className="mt-1 text-xs">
        This model was bulk-uploaded and is waiting for confirmation
        {blocked
          ? `. Reconcile ${pendingCount} pending material line${pendingCount === 1 ? "" : "s"} first.`
          : "."}
      </p>
      <div className="mt-2 flex gap-2">
        <button
          type="button"
          className={mfgPrimaryBtnClass}
          disabled={busy || blocked}
          onClick={() => void confirm()}
        >
          {busy ? "Confirming…" : "Confirm model"}
        </button>
        {blocked ? (
          <span className={`${mfgSecondaryBtnClass} pointer-events-none opacity-60`}>
            Pending materials block confirm
          </span>
        ) : null}
      </div>
    </div>
  );
}
